<template>
  <a :href="href">{{linkText}}</a>
</template>

<script>
export default {
  computed: {
    href() {
      let href = `mailto:${this.email}`;

      if (this.subject) {
        href = `${href}?subject=${this.subject}`
      }

      return href;
    },
    linkText() {
      return this.text || this.email
    }
  },
  data: () => ({
    email: 'contact@chefnaturelle.com'
  }),
  props: {
    subject: {
      default: '',
      type: String
    },
    text: {
      default: null,
      type: String,
    }
  }
}
</script>
